import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaGoogle,
  FaYoutube,
  FaTiktok,
  FaLinkedin,
  FaPinterest,
  FaEnvelope,
  FaMobileAlt,
  FaLaptopCode,
  FaCashRegister,
} from "react-icons/fa";
import { FaScrewdriverWrench } from "react-icons/fa6";
import { GiVideoCamera } from "react-icons/gi";
import { MdBusiness } from "react-icons/md";
import "./Services.css";

const WA_NUMBER = "971586567055"; // <- default WhatsApp number (without +)

// build a wa.me link with a dynamic message per service
const waLink = (serviceTitle) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
    `Hi AdsOn Digital Marketing Agency! I'm interested in "${serviceTitle}". Please share more details & pricing.`
  )}`;

const SERVICES = [
  { title: "Engineering Services", desc: "HVAC MEP Design Services for residential, commercial, and industrial projects.", icon: <FaScrewdriverWrench className="fb-icon" /> },
  { title: "Website Development", desc: "Modern, responsive, and SEO-friendly websites built using the latest technologies.", icon: <FaLaptopCode className="google-icon" /> },
  { title: "Mobile App Development", desc: "Custom Android & iOS apps designed for speed, scalability, and excellent UI/UX.", icon: <FaMobileAlt className="ig-icon" /> },
  { title: "POS Software Solutions", desc: "Smart Point of Sale software tailored for retail, restaurants, and businesses.", icon: <FaCashRegister className="youtube-icon" /> },
  { title: "Google Ads & Google My Business", desc: "Data-driven PPC campaigns & optimized local listings to boost visibility and conversions.", icon: <FaGoogle className="google-icon" /> },
  {
    title: "Meta Ads (Facebook & Instagram)",
    desc: "Creative and performance-focused ad campaigns for Facebook & Instagram audiences.",
    icon: (<><FaFacebook className="fb-icon" /> <FaInstagram className="ig-icon" /></>),
  },
  { title: "YouTube Ads", desc: "Engaging skippable, non-skippable, and discovery ads to enhance brand awareness.", icon: <FaYoutube className="youtube-icon" /> },
  { title: "TikTok Ads", desc: "Viral short-form content designed to capture attention and drive conversions.", icon: <FaTiktok className="tiktok-icon" /> },
  { title: "Pinterest Ads", desc: "Attractive Pinterest campaigns for lifestyle, fashion, and product branding.", icon: <FaPinterest className="linkedin-icon" /> },
  { title: "Dubbizle Ads", desc: "Targeted classifieds campaigns on Dubbizle to reach local buyers and customers.", icon: <MdBusiness className="snap-icon" /> },
  { title: "Social Media Profiles & Monetization", desc: "Complete profile creation, branding, and monetization setup across all platforms.", icon: <FaLinkedin className="linkedin-icon" /> },
  { title: "AI Models Video Ads", desc: "High-quality AI-generated video ads for unique, futuristic, and cost-effective campaigns.", icon: <FaYoutube className="youtube-icon" /> },
  { title: "Digital Marketing Course", desc: "Learn data-driven advertising strategies, social media marketing, and SEO with our expert-led courses.", icon: <FaGoogle className="google-icon" /> },
  { title: "Artificial Intelligence / AI Course", desc: "Master AI fundamentals, models, and applications with hands-on training and real-world projects.", icon: <FaLinkedin className="linkedin-icon" /> },
  { title: "Graphics & Animation", desc: "Posters, flyers, AI video content, CGI videos, and eye-catching designs.", icon: <GiVideoCamera className="youtube-icon" /> },
  { title: "Company Profiles & Catalogues", desc: "Professional profiles and catalogs that showcase your business at its best.", icon: <MdBusiness className="google-icon" /> },
  { title: "Products Branding", desc: "Innovative branding strategies to make your products unforgettable.", icon: <FaInstagram className="ig-icon" /> },
  { title: "E-Mail Marketing", desc: "Targeted email campaigns to convert leads and build customer trust.", icon: <FaEnvelope className="fb-icon" /> },
];

export default function Services() {
  return (
    <section className="services" id="services">
      <div className="services__inner">
        <h2 className="services__title">Our Services</h2>
        <p className="services__subtitle">
          We provide end-to-end solutions, from engineering to digital
          marketing, web & app development, and software solutions.
        </p>

        <div className="services__grid">
          {SERVICES.map((s, idx) => (
            <a
              key={idx}
              href={waLink(s.title)}
              target="_blank"
              rel="noreferrer"
              className="service-card-link"
            >
              <article className="service-card">
                <div className="service-card__head">
                  <span className="service-card__icon">{s.icon}</span>
                </div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </article>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
